module.exports = {
  LIMIT_EXCEED: "LIMIT_EXCEED",
  UNPUBLISHED: "UNPUBLISHED",
  OVERDUE: "OVERDUE",
  TOO_EARLY: "TOO_EARLY",
  ACTIVE: "ACTIVE",
  HAS_BEEN_USED: "HAS_BEEN_USED"
}